import Vue from "vue";

const base_url = "email_reader/errors";

export async function index() {
  return Vue.prototype.$http.get(`${base_url}`);
}

export async function show(id) {
  return Vue.prototype.$http.get(`${base_url}/${id}`);
}

export async function retry(id) {
  return Vue.prototype.$http.post(`${base_url}/${id}/retry`);
}

export async function retryAll() {
  return Vue.prototype.$http.post(`${base_url}/retry_all`);
}

export async function cancel(id) {
  return Vue.prototype.$http.delete(`${base_url}/${id}`);
}
